interface InstructionModalProps {
  onClose: () => void;
}

const InstructionModal = ({ onClose }: InstructionModalProps) => {
  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content instruction-modal" onClick={(e) => e.stopPropagation()} style={{ maxWidth: '800px', maxHeight: '90vh', overflowY: 'auto', margin: '20px' }}>
        <div className="modal-header">
          <h2 style={{ margin: 0, textAlign: 'center', width: '100%', fontSize: '24px' }}>Instrukcja obsługi konfiguratora</h2>
          <button className="modal-close" onClick={onClose}>&times;</button>
        </div>
        <div className="modal-body" style={{ padding: '20px', textAlign: 'left' }}>
          
          <section style={{ marginBottom: '25px' }}>
            <h3 style={{ color: 'var(--accent)', marginBottom: '10px' }}>1. Wyszukiwanie wkładu kominkowego</h3>
            <p>Po zalogowaniu wyświetlą się kafelki z dostępnymi produktami. Wkład kominkowy można odnaleźć na dwa sposoby:</p>
            <ul>
              <li><strong>Przeglądanie kafelków</strong> - produkty podzielone są na kategorie i modele</li>
              <li><strong>Wyszukiwarka</strong> - w opcji "Szukaj" można wpisać nazwę szukanego modelu</li>
            </ul>
          </section>

          <section style={{ marginBottom: '25px' }}>
            <h3 style={{ color: 'var(--accent)', marginBottom: '10px' }}>2. Konfiguracja wkładu</h3>
            <p>Po wybraniu modelu rozpoczyna się proces konfiguracji. Opcje podzielone są na dwie grupy:</p>
            <ul>
              <li><strong>Opcje wymagane</strong> - wszystkie opcje od początku listy aż do sekcji "Akcesoria" muszą zostać wybrane. Dopiero po ich zaznaczeniu pojawi się możliwość przejścia do podsumowania.</li>
              <li><strong>Akcesoria</strong> - opcje dodatkowe, które można wybrać według potrzeb</li>
            </ul>
            <p>Wybrane opcje są na bieżąco wyświetlane w oknie podglądu po prawej stronie ekranu w wersji szerokoekranowej, a w wersji mobilnej pod opcjami konfiguratora, gdzie można wizualnie śledzić konfigurowany wkład.</p>
          </section>

          <section style={{ marginBottom: '25px' }}>
            <h3 style={{ color: 'var(--accent)', marginBottom: '10px' }}>3. Zarządzanie ceną</h3>
            <p>Cena wybranej konfiguracji wyświetlana jest na dole ekranu w formie kafelka. Dostępne funkcje:</p>
            <ul>
              <li><strong>Zmiana rodzaju ceny</strong> - przycisk w prawym górnym rogu kafelka z ceną pozwala przełączać się między: ceną NETTO, ceną z VAT 8% oraz ceną z VAT 23%</li>
              <li><strong>Ukrywanie ceny</strong> - przycisk z minusem (-) po lewej stronie ceny pozwala ukryć cenę</li>
            </ul>
          </section>

          <section style={{ marginBottom: '25px' }}>
            <h3 style={{ color: 'var(--accent)', marginBottom: '10px' }}>4. Podsumowanie i generowanie PDF</h3>
            <p>Po wybraniu wszystkich wymaganych opcji można przejść do podsumowania, które zawiera:</p>
            <ul>
              <li>Pełną listę wybranych elementów</li>
              <li>Wygenerowany kod produktu</li>
              <li>Możliwość dodania nazwy dystrybutora</li>
              <li>Możliwość dodania uwag</li>
            </ul>
            <p>Po uzupełnieniu powyższych pól można wygenerować plik PDF z kompletną konfiguracją.</p>
          </section>

          <section style={{ marginBottom: '25px' }}>
            <h3 style={{ color: 'var(--accent)', marginBottom: '10px' }}>5. Składanie zamówienia</h3>
            <p>Wygenerowany plik PDF należy wysłać na adres e-mail: <strong>unico@unico-kominki.pl</strong></p>
            <p>Przesłany plik jest traktowany jako zamówienie.</p>
          </section>

          <section style={{ marginBottom: '25px' }}>
            <h3 style={{ color: 'var(--accent)', marginBottom: '10px' }}>6. Zapisywanie i wczytywanie konfiguracji</h3>
            <p>W podsumowaniu oraz w pliku PDF generowany jest kod produktu. Kod ten pozwala na późniejsze ponowne wczytanie tej samej konfiguracji:</p>
            <ul>
              <li>W opcji "Kod produktu" (obok opcji "Szukaj") należy wkleić lub wpisać kod produktu wygenerowany przy podsumowaniu</li>
              <li>Konfigurator automatycznie zaznaczy wszystkie wcześniej wybrane opcje</li>
            </ul>
          </section>

          <section style={{ marginBottom: '25px' }}>
            <h3 style={{ color: 'var(--accent)', marginBottom: '10px' }}>7. Strefa klienta</h3>
            <p>Panel logowania do strefy klienta jest obecnie w fazie przygotowań.</p>
          </section>

          <div style={{ textAlign: 'center', marginTop: '30px', paddingTop: '20px', borderTop: '1px solid var(--line)' }}>
            <p style={{ fontStyle: 'italic', color: 'var(--muted)' }}>Życzymy miłego korzystania z konfiguratora!</p>
            <p style={{ fontWeight: 'bold' }}>Unico - Kominki</p>
            <p style={{ color: 'var(--accent)' }}>unico@unico-kominki.pl</p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default InstructionModal
